import * as React from 'react';
import {flow, get, forEach, each} from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import NavigationBar from '../../components/NavigationBar';
import {Col, ControlLabel, Form, FormGroup, Row} from 'react-bootstrap';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import {Field, FieldArray, formValueSelector, InjectedFormProps, reduxForm} from 'redux-form';
import {IAuthState} from '../../../../services/auth/models';
import {
  IChannel,
  ICustomer,
  IDeclaration,
  IProduct,
  QuoteStatus,
  IClaim,
  IVehicle,
  IDriver,
} from '../../../../data/api/models';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import DeclinesAndReferrals from '../../components/DeclinesAndReferrals';
import {getReferralsAndDeclines} from '../../../../util/helpers';
import FieldFormControl from '../../../../components/FieldFormControl';
import FaCheck from 'react-icons/fa/check';
import {isRequired} from '../../../../util/validators';
import Drivers from './components/Drivers';
import Claims from './components/Claims';
import Convictions from './components/Convictions';

interface IDriversFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  actions: {
    quote: IQuoteActions;
  };
  drivers: any;
  driverCount: number;
  declaration: any;
  customerType: string;
  personalCustomer: boolean;
  insured: ICustomer;
  vehicles: IVehicle[];
}

class DriversForm extends React.Component<IDriversFormProps> {
  public state = {
    declines: [],
    referrals: [],
    errors: [],
    referred: false,
  };

  public componentWillReceiveProps(nextProps) {
    const { quote, actions, declaration, personalCustomer, insured } = this.props;

    const referralsAndDeclines = getReferralsAndDeclines(quote);
    if (this.state.declines !== referralsAndDeclines.declines) {
      this.setState({ declines: referralsAndDeclines.declines });
    }
    if (this.state.referrals !== referralsAndDeclines.referrals) {
      this.setState({referrals: referralsAndDeclines.referrals});
      if (!referralsAndDeclines.declines.length && referralsAndDeclines.referrals.length) {
        this.setState({referred: true});
        setTimeout((() => {
          actions.quote.referralQuote(quote.application.id, referralsAndDeclines.referrals);
        }), 2000);
      }
    }
    if (this.state.errors !== referralsAndDeclines.errors) {
      this.setState({ errors: referralsAndDeclines.errors });
    }

    forEach(declaration, (val, key) => {
      if (val !== get(nextProps.declaration, key)) {
        return this.updateDeclaration(nextProps);
      }
    });

    if (personalCustomer && (
      get(insured, 'metadata.claims') !== get(nextProps.insured, 'metadata.claims') ||
      get(insured, 'metadata.convictions') !== get(nextProps.insured, 'metadata.convictions')
    )) {
      this.updateProposerDriverClaims(
        get(nextProps.insured, 'metadata.claims'),
        get(nextProps.insured, 'metadata.convictions'),
      );
    }
  }

  private updateProposerDriverClaims(claims, convictions) {
    const { drivers } = this.props;
    let proposerDriverIndex = -1;
    each(drivers, (driver, key) => {
      if (driver.proposer) {
        proposerDriverIndex = parseInt(key, 10);
        return;
      }
    });
    if (proposerDriverIndex > -1) {
      const driver: IDriver = drivers[proposerDriverIndex];
      driver.claims = claims;
      driver.convictions = convictions;
      drivers[proposerDriverIndex] = driver;
    }
  }

  private updateDeclaration(nextProps) {
    const { dispatch, change, declaration, drivers, insured, customerType } = nextProps;

    const proposerClaimDeclarationIndex = customerType === 'individual' ? 14 : 13;

    if (declaration[11] === 'false') {
      dispatch(change('insured.metadata.convictions', []));
      forEach(drivers, (driver, index) => {
        dispatch(change(`drivers[${index}].convictions`, []));
      });
    }
    if (declaration[18] === 'false') {
      dispatch(change('insured.metadata.claims', []));
      dispatch(change(customerType === 'individual' ? 'declaration.14' : 'declaration.13', 'false'));
      declaration[proposerClaimDeclarationIndex] = 'false';
      forEach(drivers, (driver, index) => {
        dispatch(change(`drivers[${index}].claims`, []));
      });
    }
    if (declaration[proposerClaimDeclarationIndex] === 'false') {
      dispatch(change('insured.metadata.claims', []));
    } else if (declaration[proposerClaimDeclarationIndex] === 'true' && insured.metadata.claims.length === 0) {
      dispatch(change('insured.metadata.claims', [{
        date: '',
        type: '',
        cost: 0,
        fault: '',
        open: '',
      }]));
    }

    if (customerType === 'individual') {
      dispatch(change('declaration.13', declaration[11]));
    }
  }

  private validateDeclaration() {
    const {declaration} = this.props;
    if (declaration && declaration[17] === 'true') {
      return false;
    }
    return true;
  }

  private checkPageComplete() {
    const {customerType, declaration, drivers} = this.props;

    const proposerClaimDeclarationIndex = customerType === 'individual' ? 14 : 13;
    if (declaration[18] === 'true' && declaration[proposerClaimDeclarationIndex] === 'false') {
      if (drivers.length < 1) {
        return false;
      } else {
        let driversWithClaims = 0;
        each(drivers, (driver) => {
          if (driver.claims.length > 0) {
            driversWithClaims += 1;
          }
        });
        if (!driversWithClaims) {
          return false;
        }
      }
    }

    if (declaration[11] === 'true') {
      if (drivers.length < 1) {
        return false;
      } else {
        let driversWithConvictions = 0;
        each(drivers, (driver) => {
          if (driver.convictions.length > 0) {
            driversWithConvictions += 1;
          }
        });
        if (!driversWithConvictions) {
          return false;
        }
      }
    }

    return true;
  }

  private declinesOrReferrals() {
    const {declines, referrals, errors} = this.state;

    if (!declines.length && !referrals.length && !errors.length) {
      return null;
    }

    if (! declines.length && this.props.quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
      return null;
    }

    return (
      <div>
        <DeclinesAndReferrals
          declines={declines}
          referrals={referrals}
          errors={errors}
          quoteReference={this.props.quote.application.quoteReference}
          renewal={this.props.renewal}
          channel={this.props.channel}
        />
        {(! declines.length && ! referrals.length && errors.length) && (
          <NavigationBar
            hasBackButton={true}
            backTo={'/proposer'}
            hasNextButton={false}
          />
        )}
      </div>
    );
  }

  private claimOptions() {
    const { quote } = this.props;
    const types = get(quote, 'quotes.standard.annual.scheme.metadata.claim_types', {});

    return Object.values(types).map((type) => {
      return { label: type, value: type };
    });
  }

  private convictionOptions() {
    const { quote } = this.props;
    const types = get(quote, 'quotes.standard.annual.scheme.metadata.conviction_types', {});

    return Object.keys(types).map((type) => {
      return { label: type, value: type };
    });
  }

  private convictionDescriptions() {
    const { quote } = this.props;
    const types = get(quote, 'quotes.standard.annual.scheme.metadata.conviction_types', {});

    const descriptions = [];
    forEach(types, (value, code) => {
      descriptions[code] = value.description;
    });
    return descriptions;
  }

  private renderDriverDeclaration() {
    const { channel, declaration, customerType } = this.props;

    const proposerClaimDeclarationIndex = customerType === 'individual' ? 14 : 13;

    return (
      <div className="sub-content-container">
        <FormGroup controlId={'declaration.11'}>
          <Col componentClass={ControlLabel} sm={9}>
            In the past 5 years have you or any other driver received any motoring convictions, driving licence
            endorsements or fixed penalties, and/or have you been disqualified from driving (including any pending
            prosecutions)?
          </Col>
          <Col sm={3}>
            <Col sm={12}>
              <Row className="button-group-container">
                <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                  <Field
                    name="declaration[11]"
                    type="radio"
                    value="false"
                    component={FieldFormControl}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn'}>
                      No
                      <FaCheck/>
                    </div>
                  </Field>
                </Col>
                <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                  <Field
                    name="declaration[11]"
                    type="radio"
                    value="true"
                    component={FieldFormControl}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn'}>
                      Yes
                      <FaCheck/>
                    </div>
                  </Field>
                </Col>
              </Row>
            </Col>
          </Col>
        </FormGroup>
        <FormGroup controlId={'declaration.17'}>
          <Col componentClass={ControlLabel} sm={9}>
            Have you or any driver ever received a custodial sentence as a result of a motoring conviction?
          </Col>
          <Col sm={3}>
            <Col sm={12}>
              <Row className="button-group-container">
                <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                  <Field
                    name="declaration[17]"
                    type="radio"
                    value="false"
                    component={FieldFormControl}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn'}>
                      No
                      <FaCheck/>
                    </div>
                  </Field>
                </Col>
                <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                  <Field
                    name="declaration[17]"
                    type="radio"
                    value="true"
                    component={FieldFormControl}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn'}>
                      Yes
                      <FaCheck/>
                    </div>
                  </Field>
                </Col>
              </Row>
            </Col>
          </Col>
        </FormGroup>
        {! this.validateDeclaration() && (
          <div className="alert alert-danger">
            <p>Thank you for your enquiry. Due to your selection we are unable to continue with your quotation online
              however please call us on {channel.phone}</p>
          </div>
        )}
        <FormGroup controlId={'declaration.18'}>
          <Col componentClass={ControlLabel} sm={9}>
            In the last 3 years, have you or any other driver had or caused any accidents, claims or damage involving
            any motor vehicle (including cars, motorbikes and/or vans), even if no claim was made and regardless of
            blame?
          </Col>
          <Col sm={3}>
            <Col sm={12}>
              <Row className="button-group-container">
                <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                  <Field
                    name="declaration[18]"
                    type="radio"
                    value="false"
                    component={FieldFormControl}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn'}>
                      No
                      <FaCheck/>
                    </div>
                  </Field>
                </Col>
                <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                  <Field
                    name="declaration[18]"
                    type="radio"
                    value="true"
                    component={FieldFormControl}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn'}>
                      Yes
                      <FaCheck/>
                    </div>
                  </Field>
                </Col>
              </Row>
            </Col>
          </Col>
        </FormGroup>
        {declaration[18] === 'true' && (
          <FormGroup controlId={'declaration.14'}>
            <Col componentClass={ControlLabel} sm={9}>
              Was there a claim on a policy in the name of the policyholder?
            </Col>
            <Col sm={3}>
              <Col sm={12}>
                <Row className="button-group-container">
                  <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                    <Field
                      name={`declaration[${proposerClaimDeclarationIndex}]`}
                      type="radio"
                      value="false"
                      component={FieldFormControl}
                      validate={[isRequired]}
                    >
                      <div className={'button-group-btn'}>
                        No
                        <FaCheck/>
                      </div>
                    </Field>
                  </Col>
                  <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                    <Field
                      name={`declaration[${proposerClaimDeclarationIndex}]`}
                      type="radio"
                      value="true"
                      component={FieldFormControl}
                      validate={[isRequired]}
                    >
                      <div className={'button-group-btn'}>
                        Yes
                        <FaCheck/>
                      </div>
                    </Field>
                  </Col>
                </Row>
              </Col>
            </Col>
          </FormGroup>
        )}
      </div>
    );
  }

  private renderProposerClaimsAndConvictions() {
    const { declaration, customerType, insured, dispatch, change } = this.props;

    const proposerClaimDeclarationIndex = customerType === 'individual' ? 14 : 13;

    return (
      <div className="sub-content-container">
        {declaration[proposerClaimDeclarationIndex] === 'true' &&
          (declaration[11] === 'false' || customerType !== 'individual') && (
          <p>Please note the claim(s) against the policyholder below.</p>
        )}
        {declaration[proposerClaimDeclarationIndex] === 'true' && declaration[11] === 'true' &&
          customerType === 'individual' && (
          <p>Please note the claim(s) against the policyholder and their motoring convictions if applicable below.</p>
        )}
        {declaration[proposerClaimDeclarationIndex] === 'false' && declaration[11] === 'true' &&
          customerType === 'individual' && (
          <p>Please note the motoring convictions against the policyholder below if applicable.</p>
        )}
        <p>{insured.companyName ? insured.companyName : (insured.firstName + ' ' + insured.lastName)}</p>
        {declaration[proposerClaimDeclarationIndex] === 'true' && (
          <FieldArray
            name={'insured.metadata.claims'}
            component={Claims}
            claimOptions={this.claimOptions()}
            claimDataPath={'insured.metadata'}
            dispatch={dispatch}
            change={change}
          />
        )}
        {customerType === 'individual' && (
          <FieldArray
            name={'insured.metadata.convictions'}
            component={Convictions}
            convictionOptions={this.convictionOptions()}
            convictionDescriptions={this.convictionDescriptions()}
            convictionDataPath={'insured.metadata'}
            dispatch={dispatch}
            change={change}
          />
        )}
      </div>
    );
  }

  private renderDriverClaimsAndConvictions() {
    const { drivers, vehicles, declaration, driverCount, dispatch, change } = this.props;

    let onlyProposerDriver = false;
    if (drivers.length === 1) {
      if (drivers[0].proposer) {
        onlyProposerDriver = true;
      }
    }
    const specifiedDriver = drivers.length > 0 && !onlyProposerDriver;

    return (
      <div>
        {(specifiedDriver || declaration[11] === 'true' || declaration[18] === 'true') && (
          <>
            <div className="margin-bottom">
              {specifiedDriver && (
                <span>Based on your previous selection we need you to provide details of the following drivers</span>
              )}
              {specifiedDriver && (declaration[11] === 'true' || declaration[18] === 'true') && (
                <span> and</span>
              )}
              {declaration[11] === 'false' && declaration[18] === 'true' && (
                <span> {specifiedDriver ? 'p' : 'P'}lease note the driver(s) claims below and add the driver(s) if
                  required</span>
              )}
              {declaration[11] === 'true' && declaration[18] === 'false' && (
                <span> {specifiedDriver ? 'p' : 'P'}lease note the driver(s) convictions below and add the driver(s) if
                  required</span>
              )}
              {declaration[11] === 'true' && declaration[18] === 'true' && (
                <span> {specifiedDriver ? 'p' : 'P'}lease note the driver(s) claims and convictions below and add the
                  driver(s) if required</span>
              )}
              <span>:</span>
            </div>
            <FieldArray
              name="drivers"
              component={Drivers}
              count={driverCount}
              dispatch={dispatch}
              change={change}
              vehicles={vehicles}
              claimOptions={this.claimOptions()}
              convictionOptions={this.convictionOptions()}
              convictionDescriptions={this.convictionDescriptions()}
            />
          </>
        )}
      </div>
    );
  }

  public render() {
    const {
      handleSubmit,
      dispatch,
      change,
      quote,
      drivers,
      driverCount,
      declaration,
      customerType,
    } = this.props;

    const declinesOrReferrals = this.declinesOrReferrals();
    if (declinesOrReferrals) {
      return declinesOrReferrals;
    }

    const hasBackButton = quote.application.status !== QuoteStatus.REFERRAL_APPROVED;
    const proposerClaimDeclarationIndex = customerType === 'individual' ? 14 : 13;

    return (
      <Form horizontal={true}
            onSubmit={handleSubmit}
            autoComplete="off">
        <div className="steps-container">
          {this.renderDriverDeclaration()}
          {declaration[11] && declaration[17] && declaration[18] && (
            <>
              {(declaration[proposerClaimDeclarationIndex] === 'true' || customerType === 'individual') && (
                <>
                  {this.renderProposerClaimsAndConvictions()}
                </>
              )}
              {this.renderDriverClaimsAndConvictions()}
            </>
          )}
          <NavigationBar
            hasBackButton={hasBackButton}
            backTo={'/vehicles'}
            {...this.props}
            nextButtonDisabled={!this.validateDeclaration() || !this.checkPageComplete()}
            hasSaveButton={true}
          />
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const drivers = selector(state, 'drivers');
      const driverCount = selector(state, 'driverCount');
      const declaration = selector(state, 'declaration');
      const customerType = selector(state, 'customerType');
      const insured = selector(state, 'insured');
      const vehicles = selector(state, 'vehicles');
      const personalCustomer = selector(state, 'personalCustomer');

      return {
        drivers,
        driverCount,
        declaration,
        customerType,
        insured,
        vehicles,
        personalCustomer,
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(DriversForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Drivers/index.tsx